import { useEffect } from 'react';

import { NextPageContext } from 'next';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

import { Languages } from 'constants/i18n';
import RegisterScreen from 'modules/event/screens/Register';

import { getRoom } from '@services/register';

import { Room as RoomType } from '@entities/Room';

interface RegisterProps {
  room: { Room: RoomType };
}

const Register = ({ room }: RegisterProps): React.ReactElement => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(Languages[room?.Room?.Linguagem]);
  }, [i18n, room?.Room?.Linguagem]);

  return (
    <>
      <Head>
        <title>{t(`register.browserTitle`)}</title>
      </Head>

      <RegisterScreen roomData={room?.Room} />
    </>
  );
};

export async function getServerSideProps(
  context: NextPageContext & { params: { roomId: string } },
) {
  try {
    const { data } = await getRoom(context.params.roomId);

    return { props: { room: data } };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

export default Register;
